export default "__VITE_ASSET__BLUKecTz__"